import * as types from "./constants";
import update from 'immutability-helper';

const initialState = {
  userAvatars: [],
  avatarsFetched: false
}

function avatarsReducer(state=initialState, action) {
  switch (action.type) {
    case types.ADD_AVATARS:
      return update(state, {
        userAvatars: {$set: action.avatars},
        avatarsFetched: {$set: true}
      });
    default:
      return state
  }
}

export default avatarsReducer;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/avatars/reducers.es6